import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import FeatherIcon from 'feather-icons-react';
import { testimonialsData } from '../../data';
import { testimonialsDataArabic } from '../../data/indexArabic';
import { useAuth } from '../../store/auth';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const TestimonialsSection = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? testimonialsData : testimonialsDataArabic;

  return (
    <React.Fragment>
      {data && (
        <Container>
          <Row className="justify-content-center">
            <Col className="col-12 text-center">
              <div className="section-title mb-4 pb-2">
                <span className="badge rounded-pill bg-soft-primary">{data?.badgeText}</span>
                <h4 className="title mt-3 mb-4">
                  {data?.titles?.map((ele, index) => (
                    <span key={index} className={ele.highlight ? 'text-primary' : ''}>
                      {ele.breakPoint && <br />}
                      {ele.title}
                    </span>
                  ))}
                </h4>
                <p className="text-muted para-desc mb-0 mx-auto">
                  {data?.description?.map((ele, index) => (
                    <span className={ele.highlight ? 'text-primary fw-bold' : ''} key={index}>
                      {ele.content}
                    </span>
                  ))}
                </p>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12 mt-4 pt-2">
              <Swiper
                slidesPerView={1}
                spaceBetween={20}
                pagination={{
                  clickable: true,
                }}
                navigation
                breakpoints={{
                  576: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 25,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
                loop={true}
                modules={[Pagination, Autoplay, Navigation]}
                className="testimonials-swiper"
                style={{ paddingBottom: '50px', paddingTop: '20px' }}
              >
                {data?.testimonials?.map((testimonial, key) => (
                  <SwiperSlide key={key} className="h-auto">
                    <Card className="border-0 shadow rounded-3 h-100" style={{ marginTop: '10px', marginBottom: '10px' }}>
                      <CardBody className="p-4 d-flex flex-column" style={{ minHeight: '280px' }}>
                        <div className="d-flex align-items-center mb-3">
                          <div className="flex-shrink-0">
                            <div className="avatar avatar-md-sm rounded-circle bg-soft-primary d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                              <FeatherIcon icon="user" className="text-primary" size={20} />
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="mb-1 fw-semibold">{testimonial.name}</h6>
                            <small className="text-muted">{testimonial.position}</small>
                          </div>
                        </div>
                        
                        <div className="mb-3 ms-4">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <FeatherIcon key={i} icon="star" className="text-warning me-1" size={16} style={{ fill: 'currentColor' }} />
                          ))}
                        </div>
                        
                        <div className="flex-grow-1 d-flex align-items-start">
                          <FeatherIcon icon="quote" className="text-primary me-2 flex-shrink-0 mt-1" size={16} />
                          <p className="text-muted mb-0 lh-base">
                            {testimonial.review}
                          </p>
                        </div>
                      </CardBody>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Col>
          </Row>
        </Container>
      )}
    </React.Fragment>
  );
};

export default TestimonialsSection;
